export default "__VITE_ASSET__fkU6oHYl__"